export const updateTopics = (selectedTopics: string[], topicId: string): string[] =>
  selectedTopics.includes(topicId) ? selectedTopics.filter((id) => id !== topicId) : [...selectedTopics, topicId];
